import React, { useState, useEffect, useRef } from "react";
import {
  Layout,
  ConfigProvider,
  Input,
  Row,
  Typography,
  Col,
  Card,
  Table,
  Spin,
  Select,
  Button,
} from "antd";
import { useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
import MainLayout from "../../../components/layouts/MainLayout";
import definedApi from "../../../services/definedApi";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { connect, useDispatch } from "react-redux";
import TopContent from "../../../components/layouts/TopContent";
import { chargeApi, chargeLabel, chargeStatic } from "./charge.config";

import { rightAction } from "../../../redux/actions";
import DownloadTableButtons from "../../../components/DownloadTableButtons";

//global distructures
const { Text, Link, Title } = Typography;
const Search = Input;
const { manageChargeItems } = chargeStatic;

const columns = [
  {
    title: "Charge Id",
    dataIndex: "key",
  },
  {
    title: "Charge Name",
    dataIndex: "name",
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: "Charge Applies to",
    dataIndex: "chargeAppliesTo",
    sorter: (a, b) => a.chargeAppliesTo.localeCompare(b.chargeAppliesTo),
  },
  {
    title: "Is Penalty",
    dataIndex: "penalty",
    render: (text) => (
      <Text strong style={{ color: text ? "green" : "red" }}>
        {text ? "Yes" : "No"}
      </Text>
    ),
  },
  {
    title: "Status",
    dataIndex: "status",
    render: (text) => (
      <Text strong style={{ color: text ? "green" : "red" }}>
        {text ? "Active" : "Inactive"}
      </Text>
    ),
  },
];

const ManageCharge = (props) => {
  const navigate = useNavigate();

  //DECLARED VARIABLES
  const {
    userData,
    // onSelectItemAction,
    rightBtn,
    rightAction,
    getGlListAction,
  } = props;
  const { session } = userData;
  const [chargeList, setChargeList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [selectedRow, setSelectedRow] = useState(null);
  const [rightViewBtn, setRightViewBtn] = useState("default");
  const dispatch = useDispatch();

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value?.toLowerCase();
    // console.log(searchKey);

    if (!searchKey) {
      setChargeList(originalList);
      return;
    }
    const filterBySearch = originalList.filter(
      (item) =>
        item?.key === parseInt(searchKey) ||
        item?.name?.toLowerCase()?.includes(searchKey.toLowerCase())
    );
    setChargeList(filterBySearch);
  }
  function selectTableCount(value) {
    setTableCount(value);
  }
  //END METHODS DECLARED

  useEffect(() => {
    //DISABLE ALL RIGHTSIDEBAR ACTION
    BOM.HasPermission("READ_CHARGE") && getCharge();
    BOM.HasPermission("CREATE_CHARGE") && rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  const getCharge = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, chargeApi.Charges, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id,
            name: element.name,
            chargeAppliesTo: element?.chargeAppliesTo?.value,
            penalty: element?.penalty,
            status: element.active,
          });
        });

        setChargeList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };

      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(body, chargeApi.Charges, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              id: element?.id,
              name: element.name,
              chargeAppliesTo: element?.chargeAppliesTo?.value,
              penalty: element?.penalty ? "Yes" : "No",
              status: element.active ? "Active" : "Inactive",
            });
          });

          resolve(tempArray);
        }
      });
    });
  };

  function handleOnView() {
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/charge-detail", { state: { id: selectedRow.id } });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnEdit() {
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-charge", { state: { id: selectedRow.id } });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/new-charge", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [
      BOM.HasPermission("READ_CHARGE") && cnt.RIGHT_DETAIL_BTN,
      BOM.HasPermission("UPDATE_CHARGE") && cnt.RIGHT_EDIT_BTN,
    ].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
    >
      <TopContent
        pageTitle={chargeLabel.manageCharge}
        pageItems={manageChargeItems}
      />

      {/* RENDER TABLE LIST */}
      <Card
        title={"Charges & Fees"}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Charge ID or Name..."
                style={{
                  width: 400,
                }}
              />
            </div>
            {/* <DownloadTableButtons
              downloadData={chargeList}
              columns={columns}
              fileName={"Charge List"}
              onExportClick={getCsvListData}
            /> */}
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={chargeList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(ManageCharge);
